export default "__VITE_ASSET__N3$IE2Y5__"